import React, { useState } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { partnershipsTranslations } from '../translations/partnerships';
import { PageSection, SectionContent, SectionTitle, BlackButton, BlackButtonLink } from '../styles/SharedStyles';

const PartnershipsContainer = styled.div`
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  background-color: white;
`;

const Section = styled(PageSection)`
  &#newsletter {
    background-color: #f9f9f9;
  }
  
  &#academy {
    background-color: white;
  }
  
  &#partnerships {
    background-color: #f9f9f9;
  }
`;


const SectionSubtitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  text-align: center;
  color: #444;
`;

const ProgramList = styled.div`
  max-width: 600px;
  margin: 1.5rem auto 0;
  text-align: center;
`;

const ProgramItem = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 1.5rem;
`;

const SectionText = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin-bottom: 2rem;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const NewsletterForm = styled.form`
  max-width: 500px;
  margin: 2rem auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const NewsletterInput = styled.input`
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  transition: border-color 0.3s ease;
  width: 100%;
  
  &:focus {
    outline: none;
    border-color: #00A651;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 2rem;
`;


const Partnerships = () => {
  const { language } = useLanguage();
  const t = partnershipsTranslations[language];
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Mock subscription
    setSubscribed(true);
    setTimeout(() => {
      setSubscribed(false);
      setEmail('');
    }, 3000);
  };
  
  return (
    <PartnershipsContainer>
      {/* Newsletter Section */}
      <Section id="newsletter">
        <SectionContent>
          <SectionTitle>{language === 'de' ? 'Newsletter' : 'Newsletter'}</SectionTitle>
          <SectionSubtitle>
            {language === 'de' 
              ? 'Bleiben Sie auf dem Laufenden mit KI-Neuigkeiten und Updates' 
              : 'Stay up to date with AI news and updates'}
          </SectionSubtitle>
          <SectionText>
            {language === 'de'
              ? 'Abonnieren Sie unseren Newsletter und erhalten Sie regelmäßig Einblicke in die neuesten KI-Entwicklungen, Fallstudien und exklusive Inhalte direkt in Ihr Postfach.'
              : 'Subscribe to our newsletter and receive regular insights into the latest AI developments, case studies, and exclusive content directly in your inbox.'}
          </SectionText>
          
          <NewsletterForm onSubmit={handleNewsletterSubmit}>
            <NewsletterInput
              type="email"
              placeholder={language === 'de' ? 'Ihre E-Mail-Adresse' : 'Your email address'}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <BlackButton type="submit">
              {subscribed 
                ? (language === 'de' ? 'Erfolgreich abonniert! ✓' : 'Successfully subscribed! ✓')
                : (language === 'de' ? 'Abonnieren' : 'Subscribe')
              }
            </BlackButton>
          </NewsletterForm>
        </SectionContent>
      </Section>
      
      {/* Plix Academy Section – hidden for now, do not delete
      <Section id="academy">
        <SectionContent>
          <SectionTitle>{language === 'de' ? 'Plix Academy' : 'Plix Academy'}</SectionTitle>
          <SectionSubtitle>
            {language === 'de' 
              ? 'KI-Weiterbildung für Fach- und Führungskräfte' 
              : 'AI Training for Professionals and Leaders'}
          </SectionSubtitle>
          <SectionText>
            {language === 'de'
              ? 'Die Plix Academy bietet praxisorientierte KI-Schulungen und Workshops für Unternehmen und Einzelpersonen. Von Grundlagen bis zu fortgeschrittenen Anwendungen – wir vermitteln das Wissen, das Sie brauchen, um KI erfolgreich in Ihrer Organisation einzusetzen.'
              : 'Plix Academy offers practical AI training and workshops for companies and individuals. From fundamentals to advanced applications – we provide the knowledge you need to successfully implement AI in your organization.'}
          </SectionText>
          <ButtonContainer>
            <BlackButtonLink href="https://www.plix-academy.de" target="_blank" rel="noopener noreferrer">
              {language === 'de' ? 'Zur Academy' : 'Visit Academy'}
            </BlackButtonLink>
          </ButtonContainer>
        </SectionContent>
      </Section>
      */}
      
      {/* Partnerships Section */}
      <Section id="partnerships">
        <SectionContent>
          <SectionTitle>{t.title}</SectionTitle>
          <SectionSubtitle>{t.subtitle}</SectionSubtitle>
          
          <ProgramList>
            <ProgramItem>{t.programs.digitalOcean}</ProgramItem>
            <ProgramItem>{t.programs.googleCloud}</ProgramItem>
            <ProgramItem>{t.programs.microsoft}</ProgramItem>
            <ProgramItem>{t.programs.ibbCoaching}</ProgramItem>
          </ProgramList>
        </SectionContent>
      </Section>
    </PartnershipsContainer>
  );
};

export default Partnerships; 